import { Contents, Background } from "../styles/ContentPage";
import Navbar from "../componentes/Navbar";
import Footer from "../componentes/Footer";
import { useNavigate } from "react-router-dom";
import { BsFillBrightnessAltHighFill } from "react-icons/bs";
import { FaHandPointDown } from "react-icons/fa";
import { GiRotaryPhone } from "react-icons/gi";
import { BiWorld } from "react-icons/bi";

const ManageSale = () => {
  const navigate = useNavigate();
  const onChangeHandle = () => {
    navigate("/");
  };
  window.scrollTo(0, 0)
  return (
    <Background>
      <Navbar onChangeHandle={onChangeHandle} />
      <div className="container-sm">
        <Contents>
          <label className="label-header">
            การจัดการการขาย คืออะไร? ทำไมทุกองค์กรควรมี
          </label>
          <div className="content">
            <div>
              <img
                src={process.env.PUBLIC_URL + "/images/Saleserv-May-P3-01.jpg"}
                alt={"การจัดการการขายคืออะไร? ทำไมทุกองค์กรควรมี"}
              />
            </div>
            <div>
              <label style={{ marginBottom: 15 }}>
                ปิดยอดขาย… ไม่ยาก เพียงแค่มี ‘ระบบการจัดการการขาย’ ที่ดี
              </label>
              <label style={{ marginBottom: 15 }}>
                'การจัดการการขาย' คืออะไร?
              </label>
              <label style={{ marginBottom: 15 }}>
                การจัดการการขาย หรือ Sale Management
                เปรียบเสมือนผู้ดูแลระบบการขายในทุกขั้นตอน ทั้งการวางแผน
                การฝึกอบรม การจัดระเบียบ การกำกับดูแล รวมถึงการประสานงาน
                เพื่อให้ทีมขายสามารถดำเนินการตามวัตถุประสงค์และบรรลุเป้าหมายที่กำหนดไว้อย่างต่อเนื่อง
                ซึ่งถึงแม้ว่ากระบวนการจัดการระบบขายนั้นจะแตกต่างกันในแต่ละธุรกิจ
                แต่ทุกระบบจะถูกวางไว้ภายใต้เป้าหมายเดียวกันคือการพัฒนาการขายให้ก้าวหน้า
                เพื่อการปิดการขายอย่างสมบูรณ์
              </label>
              <label style={{ marginBottom: 15 }}>
                เพราะการมีระบบจัดการการขายที่ดีถือเป็นสิ่งสำคัญที่สุด เนื่องจาก
                #ทีมขาย มีผลโดยตรงต่อรายได้ขององค์กร
                การมีตัวช่วยในการพัฒนาระบบถือเป็นสิ่งสำคัญที่ทำให้การวางกลยุทธ์การขายมีประสิทธิภาพสูงสุด
              </label>
              <label style={{ marginBottom: 15 }}>
                SaleServ
                เครื่องมือที่จะช่วยบริหารจัดการทีมขายและยอดขายขององค์กรคุณให้มีประสิทธิภาพสูงสุด
              </label>
              <label style={{ marginBottom: 15 }}>
                Better Sales, Better Service
                เครื่องมือช่วยเพิ่มประสิทธิภาพในการบริหารจัดการทีมขายและยอดขาย
              </label>

              <label>
                ติดต่อสอบถามเพิ่มเติมได้ที่ <FaHandPointDown color="#d1ad8e" />
              </label>
              <label>
                <BsFillBrightnessAltHighFill /> Inbox : m.me/SaleServ.co
              </label>
              <label>
                <GiRotaryPhone color="#b50d1b" /> Tel : 02-0072421
              </label>
              <label style={{ marginBottom: 15 }}>
                <BiWorld color="#0fad4c" /> Website:{" "}
                <a href=" https://SaleServ.co">https://SaleServ.co</a>
              </label>
              <label>
                #SaleServ #เว็บไซต์ #การจัดการทีมขาย #BetterSalesBetterService
              </label>
            </div>
          </div>
        </Contents>
      </div>
      <Footer />
    </Background>
  );
};

export default ManageSale;
